import React from 'react';
import Card from '../components/Card';
import DoughnutChart from '../components/DoughnutChart';
import BarChart from '../components/BarChart';
import LineChart from '../components/LineChart';
import ServerListGroup from '../components/ServerListGroup';

export default function Dashboard() {
  return (
    <div className=''>
      <h1>Dashboard</h1>
      <div className='d-flex flex-wrap m-3 gap-3'>
        <ServerListGroup />
        <Card title="차트1" text="차트설명" chartComponent={<DoughnutChart />}/>
        <Card title="차트2" text="차트설명" chartComponent={<BarChart />}/>
        <Card title="차트3" text="차트설명" chartComponent={<LineChart />}/>
        <Card title="차트4" text="차트설명" chartComponent={<DoughnutChart />}/>
        <Card title="차트5" text="차트설명" chartComponent={<DoughnutChart />}/>
      </div>
    </div>
  );
};